/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";


import HeaderLight from "../../../../common/header/HeaderOne";
import FooterOne from "../../../../common/footer/FooterOne";

const products = () => {
  return (
    <>

<h4 className="text-dark fw-500 pb-2 fs-4">Recent Blogs</h4>
        <ul className="list-unstyled ps-0 mb-0">
          <li>Optimizing Customer Service with AI-powered Solutions</li>
          <li>Building a Fortress: Enhancing Web Security in 2024</li>
          <li>
            The Digital Craftsmen: Essential Tech for Next-Gen Product
            Development
          </li>
          <li>
            Scaling Success: The Top 5 Customer Success Strategies Winning
            Today’s Tech Race
          </li>
          <li>Customer Success: The Engine of Enduring Business Triumph</li>
        </ul>
    
    </>
       
     
  );
};

export default products;
